module.exports = __webpack_public_path__ + "static/logo_mactenova_original-f3a7146163cca77bb78b635984776714.png";